<template>
  <div class="user-box">
    <div class="user-manage">
      <div class="top">
        <div class="left">账户列表</div>
        <el-button type="primary" class="add-input" @click="setUser(false)">新增账户</el-button>
      </div>
      <div class="table-box">
        <el-table :data="tableData" style="width: 100%">
          <!-- <el-table-column prop="index" label="编号"> </el-table-column> -->
          <el-table-column label="序号" type="index" align="center" width="50x">
          </el-table-column>
          <el-table-column prop="username" label="账号"> </el-table-column>
          <el-table-column prop="name" label="姓名"> </el-table-column>
          <!-- <el-table-column prop="phone" label="手机号"> </el-table-column> -->
          <el-table-column prop="roleNames" label="角色"> </el-table-column>
          <el-table-column prop="mobile" label="手机号"> </el-table-column>
          <el-table-column prop="accsms" label="接收报警短信">
            <template slot-scope="scope">
              <el-tag  v-if="scope.row.accsms==1">是</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="创建时间">
          </el-table-column>
          <el-table-column prop="edit" label="操作" width="120">
            <template slot-scope="scope">
              <div class="btn-out-box">
                <div class="btn-box color1 active" @click="setUser(scope.row)">
                  <i class="iconfont icon-bianji1"></i>
                </div>
                <div
                  class="btn-box color2 active"
                  @click="deleteUser(scope.row)"
                >
                  <i class="iconfont icon-close"></i>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <!-- <el-pagination
          class="m-t-20"
          background
          :current-page.sync="currentPage"
          layout="prev, pager, next"
          :total="total"
          @current-change="paginationHandle"
        >
        </el-pagination> -->
        <div class="pagination-info">
          <div class="left">
            第 {{ currentPage }} 页（共{{ Math.ceil(total / size) }}页），显示{{
              (currentPage - 1) * size + 1
            }}至{{
              currentPage * size >= total ? total : currentPage * size
            }}项结果，共{{ total }}项
          </div>
          <div class="right">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="paginationHandle"
              :page-sizes="[5, 10, 15, 20]"
              :page-size="size"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
            >
            </el-pagination>
          </div>
        </div>
      </div>
      <el-dialog
        title="新增/编辑账户"
        :visible.sync="dialogFormVisible"
        :modal-append-to-body="false"
      >
        <el-form :label-position="'right'" label-width="120px" :model="form">
          <el-form-item label="账号：">
            <el-input
              v-model="form.username"
              onkeyup="value=value.replace(/[^\w\.\/]/ig,'')"
            ></el-input>
          </el-form-item>
          <el-form-item label="姓名：">
            <el-input v-model.trim="form.name"></el-input>
          </el-form-item>
          <el-form-item label="密码：">
            <el-input v-model.trim="form.password"></el-input>
          </el-form-item>
          <el-form-item label="选择项目：">
            <!-- <el-radio-group class="form-radio-box" v-model="form.projectIds">
              <el-radio
              class="el-form-item-20"
                v-for="(item, index) in projectList"
                :key="index"
                :label="item.id + ''"
                @click.native="onClickRadio(item)"
                >{{ item.projectName }}</el-radio
              >
            </el-radio-group> @click.native="onClickForm(item, index)"-->
            <el-checkbox-group v-model="form.projectIds" @change="onClickForm">
              <!-- class="el-form-item-20"  @click.native="onClickRadio(item)" -->
              <el-checkbox
                v-for="(item, index) in projectList"
                :key="index"
                :label="item.id"
                >{{ item.projectName }}</el-checkbox
              >
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="角色配置：">
            <el-radio v-model="form.roleId" label="3">实施技术员</el-radio>
            <!-- <el-radio v-model="form.roleId" label="5">平台管理员</el-radio> -->
            <el-radio v-model="form.roleId" label="4">配置工程师</el-radio>
            <el-radio v-model="form.roleId" label="5">项目主管</el-radio>
            <el-radio v-model="form.roleId" label="6">管理员</el-radio>
          </el-form-item>
          <el-form-item label="手机号：">
            <el-input v-model.trim="form.mobile" type="number"></el-input>
          </el-form-item>
           <el-form-item label="接收报警短信：">
             <el-switch
              v-model="form.accsms"
              active-color="#13ce66"
              :active-value="1"
              :inactive-value="0">
            </el-switch>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="addUserHandle">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>

import {
  Message
} from 'element-ui';
import tool from "../../utils/tool";
import qs from "qs";
export default {
  data() {
    return {
      tableData: [],
      isAdd: true,
      dialogFormVisible: false,
      projectList: [],
      form: {
        username: "",
        name: "",
        password: "",
        projectIds: [],
        roleId: "4",
        mobile:"",
        accsms:0
      },
      currentPage: 1,
      size: 10,
      total: 0,
    };
  },
  created() {
    this.id = this.$route.params.id;
    this.searchManagerUsers();
    this.searchProjectList();
  },
  methods: {
    paginationHandle(index) {
      this.currentPage = index;
      this.searchManagerUsers();
      this.searchProjectList();
    },
    handleSizeChange(e) {
      this.currentPage = 1;
      this.size = e;
      this.searchManagerUsers();
      this.searchProjectList();
    },
    onClickForm(val) {
      // console.log(val);
    },
    searchProjectList() {
      this.$http
        .post("bma-user-service/project/searchProjectList", {
          currentPage: 1,
          projectName: "",
          size: 500,
        })
        .then((res) => {
          // console.log(res);
          if (res.code == 200) {
            this.projectList = res.data.records;
            this.total = res.data.total;
          }
        });
    },
    searchManagerUsers() {
      this.$http
        .post("bma-user-service/user/searchManagerUsers", {
          currentPage: this.currentPage,
          size: this.size,
        })
        .then((res) => {
          // console.log("res: ", res);
          let arr = [];
          this.total = res.data.total;
          res.data.records.forEach((item, index) => {
            item.index = index + 1;
            item.roleCheckedList.forEach((i) => {
              if (i.checked) {
                item.roleId = i.id + "";
              }
            });
            // if (item.status) {
            arr.push(item);
            // }
          });
          this.tableData = arr;
        });
    },
    setUser(e) {
      // false 新增
      if (e) {
        // 编辑
        this.isAdd = false;
        this.form.id = e.id;
        this.form.username = e.username;
        this.form.name = e.name;
        this.form.password = e.password;
        this.form.status = e.status;
        this.form.locked = e.locked;
        this.form.roleId = e.roleId;
        this.form.mobile = e.mobile;
        this.form.accsms = e.accsms;
        this.filterProjectId(e.projectList);
        this.dialogFormVisible = true;
      } else {
        // 新增
        this.isAdd = true;
        this.form = {
          name: "",
          username: "",
          password: "",
          roleId: "",
          projectIds: [],
          mobile:"",
          accsms:0
        };
        this.dialogFormVisible = true;
      }
    },
    // 筛选出项目id
    filterProjectId(data) {
      let parr = [];
      data.forEach((item) => {
        if (item.isChecked) {
          parr.push(item.id);
        }
      });

      this.form.projectIds = parr;
    },
    addUserHandle() {
      this.dialogFormVisible = false;
      if (this.isAdd) {
        this.addManagerUsers();
      } else {
        this.updateUserInfo();
        this.updateAccountUserRole();
        this.distributionUserProjects();
      }
    },
    // 编辑角色
    updateAccountUserRole() {
      this.$http
        .post("bma-user-service/user/updateAccountUserRole", {
          roleId: Number(this.form.roleId),
          userId: this.form.id,
        })
        .then((res) => {
          if (res.code == 200) {
            this.searchUsersByProject();
          }
        });
    },
    // 编辑项目
    distributionUserProjects() {
      // console.log("0000");
      //  // console.log(this.form.projectIds)
      this.$http
        .post("bma-user-service/project/distributionUserProjects", {
          projectIds: this.form.projectIds.join(","),
          userId: this.form.id,
        })
        .then((res) => {
          if (res.code == 200) {
            this.searchUsersByProject();
          }
        });
    },
    updateUserInfo() {
      // console.log(this.form);
      this.$http
        .post("bma-user-service/user/updateUserInfo", {
          id: this.form.id,
          name: this.form.name,
          username: this.form.username,
          password: this.form.password,
          locked: this.form.locked,
          mobile:this.form.mobile,
          accsms:this.form.accsms
        })
        .then((res) => {
          // console.log("编辑", res);
          if (res.code == 200) {
            Message.success("编辑成功");
            this.searchManagerUsers();
          }
        });
    },
    addManagerUsers() {
      // console.log(this.form);
      this.form.dataType = "";
      this.form.username = tool.filterChinese(this.form.username);
      this.form.projectIds = this.form.projectIds.join(",");
      this.$http
        .post("bma-user-service/user/addManagerUsers", this.form)
        .then((res) => {
          // console.log("xinzeng: ", res);
          if (res.code == 200) {
            Message.success("新增成功");
            this.searchManagerUsers();
          }
        });
    },
    deleteUser(e) {
      this.$confirm("确认删除此用户？")
        .then((_) => {
          this.deleteUserHandle(e);
        })
        .catch((_) => {});
    },
    deleteUserHandle(e) {
      this.$http
        .post(
          "bma-user-service/user/deleteUser",
          {
            userId: e.id,
          }
          // {
          //   headers: {
          //     userId: e.id,
          //   },
          // },
        )
        .then((res) => {
          if (res.code == 200) {
            Message.success("删除成功");
            this.currentPage = 1;
            this.searchManagerUsers();
          }
        });
    },
    setShebei(e) {
      if (!e.isOpen) return;
      this.drawer = true;
    },
  },
};
</script>

<style lang="less" scoped>
.user-box {
  padding: 20px;
}
.form-radio-box {
  margin-top: 20px;
  .el-form-item-20 {
    margin-bottom: 20px;
  }
}
.user-manage {
  background: #f8f8f9;
  padding: 20px;
  border-radius: 7px;
  .top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 10px;
    margin-bottom: 28px;
    position: relative;
    z-index: 2000;
    .left {
      font-size: 18px;
      font-weight: 600;
    }
  }
  .table-box {
    text-align: center;
    /deep/.el-table {
      background: rgba(0, 0, 0, 0);
      /deep/th,
      tr {
        background: rgba(0, 0, 0, 0);
      }
      /deep/th {
        > .cell {
          color: #152139;
          font-size: 14px;
          font-weight: 600;
          text-align: center;
        }
      }
      /deep/tr {
        td {
          font-size: 14px;
          color: #152139;
          text-align: center;
        }
      }
      .btn-out-box {
        display: flex;
        justify-content: space-around;
      }
      .btn-box {
        width: 24px;
        height: 24px;
        background: rgba(165, 165, 165, 0.1);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        .iconfont {
          font-size: 12px;
          color: rgba(195, 195, 195, 1);
        }
        &.color1.active {
          background: rgba(20, 96, 224, 0.1);
          .iconfont {
            color: rgba(20, 96, 224, 1);
          }
        }
        &.color2.active {
          background: rgba(255, 41, 41, 0.1);
          .iconfont {
            color: rgba(255, 41, 41, 1);
          }
        }
        &.color3.active {
          background: rgba(253, 151, 101, 0.1);
          .iconfont {
            color: rgba(253, 151, 101, 1);
          }
        }
      }
    }
  }
  .pagination-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 10px;
    .left {
      font-size: 12px;
      color: rgba(137, 146, 159, 1);
    }
  }
  /deep/.el-dialog {
    width: 35%;
    .el-dialog__title {
      font-weight: 600;
    }
    .el-input {
      // width: 323px;
    }
  }
}
</style>
